import React, { FormEvent } from 'react';
import { ControlLabel, FormControl, FormGroup, Panel, Radio } from 'react-bootstrap';

interface IProps {
    isWillingToMeetDonor: boolean,
    isSharingGfAndCreatinine: boolean,
    onChange: (field: string, value: any) => void
}

const PatientPrivacy = (props: IProps) => {
    const handleDataChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;

        let newValue;

        if (name == 'isWillingToMeetDonor') {
            if (parseInt(value) == 1) {
                newValue = true;
            }

            if (parseInt(value) == 0) {
                newValue = false;
            }

            if (parseInt(value) == -1) {
                newValue = null;
            }
        }

        if (name == 'isSharingGfAndCreatinine') {
            if (parseInt(value) == 1) {
                newValue = true;
            }

            if (parseInt(value) == 0) {
                newValue = false;
            }

            if (parseInt(value) == -1) {
                newValue = null;
            }
        }

        props.onChange(name, newValue);
    };

    return (
        <Panel>
            <Panel.Heading>Patient Privacy Questions</Panel.Heading>
            <Panel.Body>
                <FormGroup>
                    <ControlLabel>Is this Recipient potentially willing to remove anonymity (e.g., might be willing to meet donor if asked)</ControlLabel>
                    <FormControl.Static>
                        <Radio id='isWillingToMeetDonorYes' name='isWillingToMeetDonor' inline value={1} checked={props.isWillingToMeetDonor == true} onChange={handleDataChange}>Yes</Radio>
                        <Radio id='isWillingToMeetDonorNo' name='isWillingToMeetDonor' inline value={0} checked={props.isWillingToMeetDonor == false} onChange={handleDataChange}>No</Radio>
                        <Radio id='isWillingToMeetDonorUnknown' name='isWillingToMeetDonor' inline value={-1} checked={props.isWillingToMeetDonor == null} onChange={handleDataChange}>Unknown</Radio>
                    </FormControl.Static>
                </FormGroup>
                <FormGroup style={{ marginBottom: 0 }}>
                    <ControlLabel>Is this Recipient willing to allow donor to know how the kidney is doing (this will share Graft Survival & latest Creatinine)</ControlLabel>
                    <FormControl.Static>
                        <Radio id='isSharingGfAndCreatinineYes' name='isSharingGfAndCreatinine' inline value={1} checked={props.isSharingGfAndCreatinine == true} onChange={handleDataChange}>Yes</Radio>
                        <Radio id='isSharingGfAndCreatinineNo' name='isSharingGfAndCreatinine' inline value={0} checked={props.isSharingGfAndCreatinine == false} onChange={handleDataChange}>No</Radio>
                        <Radio id='isSharingGfAndCreatinineUnknown' name='isSharingGfAndCreatinine' inline value={-1} checked={props.isSharingGfAndCreatinine == null} onChange={handleDataChange}>Unknown</Radio>
                    </FormControl.Static>
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default PatientPrivacy;